import script from "./Receipt.vue?vue&type=script&setup=true&lang=js"
export * from "./Receipt.vue?vue&type=script&setup=true&lang=js"

import "./Receipt.vue?vue&type=style&index=0&id=2fdf7208&scoped=true&lang=css"

import exportComponent from "/home/web/mintit-agency/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fdf7208"]])

export default __exports__